export { default } from '@/components/Pages/BasedBenchmarkPage.web';
